import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const StyledCheckbox = styled(Form.Check)`
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
    input {
      cursor: not-allowed;
      &+.form-check-label {
        cursor: not-allowed;
        color: ${({ theme }) => theme.palette.grayscale[3]}
      }
    }
  }
`;
